import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getContentBlockItemsByName, getContentBlockMixedItem, getContentBlockMixedItems } from '../../../CmsActions.js';
import { getLoggedUser } from '../../../../User/UserActions.js';

import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';
import CmsBlockItem from '../../content/CmsBlockItem.js';

const DISCLAIMER_IMPORTANCES = ['danger', 'warning', 'info'];
const DISCLAIMER_ICONS = {
	danger: 'exclamation-triangle',
	warning: 'exclamation-circle',
	info: 'info-circle',
};

function getImportance(disclaimer) {
	const importance = (getContentBlockMixedItem(disclaimer, 'importance') || {}).text;
	return DISCLAIMER_IMPORTANCES.includes(importance) ? importance : 'info';
}

// A disclaimer is displayed when the current role is allowed (no role set means everyone)
// and when "now" is inside the authored display period (both bounds are optional).
function isVisible(disclaimer, role) {
	// The multiple select stores an array of roles, but a single value may have been stored before
	const allowedRoles = getContentBlockMixedItems(disclaimer, 'allowedRoles').reduce((roles, item) => roles.concat(item.text || []), []).filter(role => role);
	if(allowedRoles.length && !allowedRoles.includes(role)) {
		return false;
	}

	const dateFrom = (getContentBlockMixedItem(disclaimer, 'dateFrom') || {}).date;
	const dateTo = (getContentBlockMixedItem(disclaimer, 'dateTo') || {}).date;
	const now = moment.utc();
	if(dateFrom && now.isBefore(moment.utc(dateFrom, 'YYYY-MM-DD').startOf('day'))) {
		return false;
	}
	if(dateTo && now.isAfter(moment.utc(dateTo, 'YYYY-MM-DD').endOf('day'))) {
		return false;
	}
	return true;
}

function renderDisclaimer(disclaimer, index) {
	const importance = getImportance(disclaimer);
	const content = getContentBlockMixedItem(disclaimer, 'content');
	const action = getContentBlockMixedItem(disclaimer, 'action');
	const hasAction = !!(action && action.path && action.text);

	if(!(content && content.text) && !hasAction) {
		return null;
	}

	return (
		<Alert key={disclaimer.sort || index} color={importance} fade={false} className="d-flex align-items-center justify-content-between gap-3 mb-0 py-2 rounded-0">
			<div className="d-flex align-items-center gap-2">
				<FontAwesomeIcon icon={DISCLAIMER_ICONS[importance]} size="lg" className="flex-shrink-0" />
				<div className="disclaimer-content pt-2">
					{content && content.text && <HtmlComponent text={content.text} />}
				</div>
			</div>
			{hasAction && <CmsBlockItem item={action} type="link" className={`btn btn-${importance} btn-sm flex-shrink-0 text-nowrap`} />}
		</Alert>
	);
}

function PanelDisclaimer({ panel, role = '' }) {
	const disclaimers = getContentBlockItemsByName(panel.blocks, 'disclaimers').filter(disclaimer => isVisible(disclaimer, role));

	console.log(disclaimers)
	if(!disclaimers.length) {
		return null;
	}

	return (
		<div className="disclaimers">
			{disclaimers.map(renderDisclaimer)}
		</div>
	);
}

function mapStateToProps(store, props) {
	return {
		role: (getLoggedUser(store) || {}).role || '',
	};
}

PanelDisclaimer.propTypes = {
	panel: PropTypes.object.isRequired,
	role: PropTypes.string,
};

export default connect(mapStateToProps)(PanelDisclaimer);
